// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"6e12b538","176":"156b9a95","192":"9f27bdd1","592":"3b8b1ea5","783":"5971a762","832":"95b40acf","840":"83403e81","952":"4659494e"}[chunkId] + ".chunk.js";
};